import type { VideoContentObject } from 'models';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon, Modal, message } from 'ui';
import { useDeleteVideoMutation } from '../../../../queries';

export const useDeleteVideo = ({
  onVideoDeleted,
  videoContentObject,
}: {
  onVideoDeleted: () => Promise<void>;
  videoContentObject: VideoContentObject;
}) => {
  const { t } = useTranslation();
  const { mutateAsync: deleteVideo } = useDeleteVideoMutation();
  const [modal, contextHolder] = Modal.useModal();

  const confirm = useCallback(() => {
    modal.confirm({
      content: 'This action is irreversible!',
      icon: <Icon color="error" icon="delete-2-line" />,
      okText: 'Yes, delete',
      async onOk() {
        await deleteVideo(
          { videoId: videoContentObject.video.id },
          {
            async onSuccess() {
              message.success('Video successfully deleted.');
              await onVideoDeleted();
            },
          },
        );
      },
      title: t('Are you sure you want to delete {{name}}?', { name: videoContentObject.video.name }),
      type: 'error',
    });
  }, [deleteVideo, onVideoDeleted, t, videoContentObject.video.id, videoContentObject.video.name, modal]);
  return useMemo(() => ({ confirm, contextHolder }), [confirm, contextHolder]);
};
